import { render } from "./StartPreview.vue?vue&type=template&id=b3643c28"
import script from "./StartPreview.vue?vue&type=script&lang=js"
export * from "./StartPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__